import { Badge } from "@mantine/core";
import { PortalSubjectType } from "../../../services/admin/portalAccess.service";

interface PortalSubjectTypeBadgeProps {
  subjectType: PortalSubjectType;
}

const SUBJECT_COLORS: Record<PortalSubjectType, string> = {
  physician: "blue",
  practice: "grape",
  surgery_center: "indigo",
};

const SUBJECT_LABELS: Record<PortalSubjectType, string> = {
  physician: "Physician",
  practice: "Practice",
  surgery_center: "Surgery Center",
};

export function PortalSubjectTypeBadge({
  subjectType,
}: PortalSubjectTypeBadgeProps) {
  return (
    <Badge
      color={SUBJECT_COLORS[subjectType]}
      variant="light"
      size="sm"
      style={{ flexShrink: 0 }}
      styles={{ label: { overflow: "visible" } }}
    >
      {SUBJECT_LABELS[subjectType]}
    </Badge>
  );
}
